import columns from '../../../../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    DateColumn,
    DurationColumn,
    NonZeroNumberColumn,
    NonZeroFloatColumn,
    ExternalReceptacleLinkColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Origin operator', 'originOperator'),
        new TextColumn('Destination operator', 'destinationOperator'),
        new ExternalReceptacleLinkColumn(new TextColumn('Receptacle ID', 'receptacleId').withWidth(300)),
        new TextColumn('Departure location', 'departureLoc'),
        new DateColumn('Departure date', 'departureDate'),
        new DurationColumn('Departure time', 'departureTime'),
        new DateColumn('Arrival date', 'arrivalDate'),
        new DurationColumn('Arrival time', 'arrivalTime'),
        new NonZeroNumberColumn('Items', 'items'),
        new NonZeroNumberColumn('Items in receptacles', 'itemsInReceptacles'),
        new NonZeroFloatColumn('Weight', 'weight'),
        new TextColumn('Weight type', 'weightType'),
        new TextColumn('Mail category', 'mailCategory'),
        new TextColumn('Receptacle subclass', 'receptacleSubclass'),
        new TextColumn('Despatch subclass', 'despatchSubclass'),
        new TextColumn('Format of content', 'formatOfContent'),
        new NonZeroNumberColumn('Receptacle sequence', 'receptacleSequence'),
        new NonZeroNumberColumn('Receptacle fmt', 'receptacleFmt'),
      ],
    },
  ];
};
